import { useEffect, useRef, useState } from "react";
import { Upload, Trash2, Copy, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { uploadToCloudinary } from "@/lib/upload";

export default function MediaLibrary() {
  const [media, setMedia] = useState([]);
  const [busy, setBusy] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef();

  const load = () => api.get("/admin/media").then((r) => setMedia(r.data));
  useEffect(() => { load(); }, []);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) await uploadToCloudinary(f, "uploads");
      toast.success(`${files.length} টি ছবি আপলোড হয়েছে`);
      load();
    } catch (err) {
      toast.error(err.message || "আপলোড ব্যর্থ");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const remove = async (id) => {
    if (!window.confirm("মুছে ফেলবেন?")) return;
    await api.delete(`/admin/media/${id}`);
    load();
  };

  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("URL কপি হয়েছে"); };

  const shown = media.filter((m) => !q || (m.name || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <div className="flex items-center justify-between mb-6 gap-4 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl font-bold text-stone-800">মিডিয়া লাইব্রেরি</h1>
          <p className="text-sm text-stone-500 mt-1">Cloudinary-তে সংরক্ষিত সব ছবি</p>
        </div>
        <div className="flex items-center gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="খুঁজুন..." className="rounded-full border border-stone-200 px-4 py-2 text-sm focus:outline-none" />
          <button onClick={() => ref.current?.click()} disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[var(--c-primary)] text-white px-5 py-2 text-sm hover:bg-[var(--c-secondary)] transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} আপলোড
          </button>
          <input ref={ref} type="file" accept="image/*" multiple onChange={onFiles} className="hidden" />
        </div>
      </div>

      {shown.length === 0 ? (
        <div className="bg-white rounded-2xl border border-stone-200 p-12 text-center text-stone-400">
          <ImageIcon className="h-10 w-10 mx-auto mb-3" /> কোনো ছবি নেই। আপলোড করুন।
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {shown.map((m) => (
            <div key={m.id} className="group relative rounded-xl overflow-hidden border border-stone-200 bg-white">
              <img src={m.url} alt={m.name} className="w-full h-32 object-cover" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <button onClick={() => copy(m.url)} className="grid place-items-center h-9 w-9 rounded-full bg-white text-stone-700"><Copy className="h-4 w-4" /></button>
                <button onClick={() => remove(m.id)} className="grid place-items-center h-9 w-9 rounded-full bg-white text-red-500"><Trash2 className="h-4 w-4" /></button>
              </div>
              <div className="px-2 py-1.5 text-xs text-stone-500 truncate">{m.name || "image"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
